// Currency behavior for grid columns.
//
// Formats numeric values as USD currency and strips non-numeric characters
// on input so pasted or typed values like "$1,234.56" are stored as 1234.56.
//
// Column def:  { field: "purchasePrice", behavior: "currency" }

import { createBehavior } from "./create_behavior"

export const currency = createBehavior({
  valueFormatter({ value }) {
    if (value == null || value === "") return ""
    const num = parseFloat(value)
    if (isNaN(num)) return value
    return num.toLocaleString("en-US", { style: "currency", currency: "USD" })
  },
  valueSetter({ newValue, data, colDef }) {
    const cleaned = String(newValue ?? "").replace(/[^0-9.\-]/g, "")
    const num = parseFloat(cleaned)
    data[colDef.field] = isNaN(num) ? null : num
    return true
  }
})
